import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, en_US, zh_CN } from 'ng-zorro-antd/i18n';
import { AppComponent } from 'src/app/app.component';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-custom-config',
  templateUrl: './custom-config.component.html',
  styleUrls: ['./custom-config.component.scss']
})
export class CustomConfigComponent implements OnInit {

  theme = 'industry';
  language = 'zh';

  constructor(
    private translate: TranslateService,
    private i18n: NzI18nService,
    private themeService: ThemeService,
    private appComponent: AppComponent,
  ) { }

  ngOnInit(): void {
    // 设置主题和语言
    this.setConfig();
  }

  setConfig() {
    const config: any = localStorage.getItem('template_config') || '{}';
    const { language = 'zh', theme = 'industry' } = JSON.parse(config);
    this.theme = theme;
    this.language = language;
  }

  onChangeTheme(theme: string) {
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
      config = { ...config, theme };
    } else {
      config = { theme };
    }
    this.theme = theme;
    this.themeService.setTheme(theme);
    this.themeService.loadTheme(false);
    localStorage.setItem('template_config', JSON.stringify(config));
  }

  onChangeLanguage() {
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
      config = { ...config, language: this.language };
    } else {
      config = { language: this.language };
    }
    localStorage.setItem('template_config', JSON.stringify(config));
    //this.appComponent.translateMenu(this.language);
    this.translate.use(this.language);
    this.i18n.setLocale(this.language === 'en'? en_US : zh_CN);
  }

}
